// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/kycb/api/identities/firstparty/v1/create_fourthline_process.proto

/* oxlint-disable */

/** Request message for CreateFourthlineProcess. */
export interface ApiCreateFourthlineProcessRequest {
  /** The identity ID to create a Fourthline process for (path parameter). */
  readonly identityId: string;
}

/** Response message for CreateFourthlineProcess. */
export interface ApiCreateFourthlineProcessResponse {
  /** The Fourthline verification process ID. */
  readonly id: string;
  /** Token used to authenticate with the Fourthline provider SDK. */
  readonly providerToken: string;
  /** URL to redirect the user to for the Fourthline verification flow. */
  readonly redirectUrl: string;
  /** Whether a Qualified Electronic Signature (QES) is required. */
  readonly isQesRequired: boolean;
}

/** Error definitions for CreateFourthlineProcess. */
export interface ApiCreateFourthlineProcessErrors {
}

/** Not found error codes. */
export const ApiCreateFourthlineProcessErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error. */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_IDENTITY_NOT_FOUND - Identity with the given ID was not found. */
  NOT_FOUND_ERROR_IDENTITY_NOT_FOUND: "NOT_FOUND_ERROR_IDENTITY_NOT_FOUND",
  /** NOT_FOUND_ERROR_CHECK_NOT_FOUND - Fourthline check record was not found. */
  NOT_FOUND_ERROR_CHECK_NOT_FOUND: "NOT_FOUND_ERROR_CHECK_NOT_FOUND",
} as const;

export type ApiCreateFourthlineProcessErrorsNotFoundError =
  typeof ApiCreateFourthlineProcessErrorsNotFoundError[keyof typeof ApiCreateFourthlineProcessErrorsNotFoundError];

export namespace ApiCreateFourthlineProcessErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED =
    typeof ApiCreateFourthlineProcessErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_IDENTITY_NOT_FOUND =
    typeof ApiCreateFourthlineProcessErrorsNotFoundError.NOT_FOUND_ERROR_IDENTITY_NOT_FOUND;
  export type NOT_FOUND_ERROR_CHECK_NOT_FOUND =
    typeof ApiCreateFourthlineProcessErrorsNotFoundError.NOT_FOUND_ERROR_CHECK_NOT_FOUND;
}

export function apiCreateFourthlineProcessErrorsNotFoundErrorFromJSON(
  object: any,
): ApiCreateFourthlineProcessErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiCreateFourthlineProcessErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_IDENTITY_NOT_FOUND":
      return ApiCreateFourthlineProcessErrorsNotFoundError.NOT_FOUND_ERROR_IDENTITY_NOT_FOUND;
    case 2:
    case "NOT_FOUND_ERROR_CHECK_NOT_FOUND":
      return ApiCreateFourthlineProcessErrorsNotFoundError.NOT_FOUND_ERROR_CHECK_NOT_FOUND;
    default:
      return ApiCreateFourthlineProcessErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiCreateFourthlineProcessErrorsNotFoundErrorToJSON(
  object: ApiCreateFourthlineProcessErrorsNotFoundError,
): string {
  switch (object) {
    case ApiCreateFourthlineProcessErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiCreateFourthlineProcessErrorsNotFoundError.NOT_FOUND_ERROR_IDENTITY_NOT_FOUND:
      return "NOT_FOUND_ERROR_IDENTITY_NOT_FOUND";
    case ApiCreateFourthlineProcessErrorsNotFoundError.NOT_FOUND_ERROR_CHECK_NOT_FOUND:
      return "NOT_FOUND_ERROR_CHECK_NOT_FOUND";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

/** Unprocessable entity error codes. */
export const ApiCreateFourthlineProcessErrorsUnprocessableEntityError = {
  /** UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED - Unspecified unprocessable entity error. */
  UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED: "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED",
  /** UNPROCESSABLE_ENTITY_ERROR_KYC_PROCESS_NOT_RETRYABLE - The membership KYC status does not allow retrying the process. */
  UNPROCESSABLE_ENTITY_ERROR_KYC_PROCESS_NOT_RETRYABLE: "UNPROCESSABLE_ENTITY_ERROR_KYC_PROCESS_NOT_RETRYABLE",
  /** UNPROCESSABLE_ENTITY_ERROR_VALIDATION_ERROR - Validation error from the KYC reporting service. */
  UNPROCESSABLE_ENTITY_ERROR_VALIDATION_ERROR: "UNPROCESSABLE_ENTITY_ERROR_VALIDATION_ERROR",
  /** UNPROCESSABLE_ENTITY_ERROR_FAILED_TO_SPLIT_DOCUMENT - Failed to split the uploaded document. */
  UNPROCESSABLE_ENTITY_ERROR_FAILED_TO_SPLIT_DOCUMENT: "UNPROCESSABLE_ENTITY_ERROR_FAILED_TO_SPLIT_DOCUMENT",
} as const;

export type ApiCreateFourthlineProcessErrorsUnprocessableEntityError =
  typeof ApiCreateFourthlineProcessErrorsUnprocessableEntityError[
    keyof typeof ApiCreateFourthlineProcessErrorsUnprocessableEntityError
  ];

export namespace ApiCreateFourthlineProcessErrorsUnprocessableEntityError {
  export type UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED =
    typeof ApiCreateFourthlineProcessErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  export type UNPROCESSABLE_ENTITY_ERROR_KYC_PROCESS_NOT_RETRYABLE =
    typeof ApiCreateFourthlineProcessErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_KYC_PROCESS_NOT_RETRYABLE;
  export type UNPROCESSABLE_ENTITY_ERROR_VALIDATION_ERROR =
    typeof ApiCreateFourthlineProcessErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_VALIDATION_ERROR;
  export type UNPROCESSABLE_ENTITY_ERROR_FAILED_TO_SPLIT_DOCUMENT =
    typeof ApiCreateFourthlineProcessErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_FAILED_TO_SPLIT_DOCUMENT;
}

export function apiCreateFourthlineProcessErrorsUnprocessableEntityErrorFromJSON(
  object: any,
): ApiCreateFourthlineProcessErrorsUnprocessableEntityError {
  switch (object) {
    case 0:
    case "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED":
      return ApiCreateFourthlineProcessErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
    case 1:
    case "UNPROCESSABLE_ENTITY_ERROR_KYC_PROCESS_NOT_RETRYABLE":
      return ApiCreateFourthlineProcessErrorsUnprocessableEntityError
        .UNPROCESSABLE_ENTITY_ERROR_KYC_PROCESS_NOT_RETRYABLE;
    case 2:
    case "UNPROCESSABLE_ENTITY_ERROR_VALIDATION_ERROR":
      return ApiCreateFourthlineProcessErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_VALIDATION_ERROR;
    case 3:
    case "UNPROCESSABLE_ENTITY_ERROR_FAILED_TO_SPLIT_DOCUMENT":
      return ApiCreateFourthlineProcessErrorsUnprocessableEntityError
        .UNPROCESSABLE_ENTITY_ERROR_FAILED_TO_SPLIT_DOCUMENT;
    default:
      return ApiCreateFourthlineProcessErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  }
}

export function apiCreateFourthlineProcessErrorsUnprocessableEntityErrorToJSON(
  object: ApiCreateFourthlineProcessErrorsUnprocessableEntityError,
): string {
  switch (object) {
    case ApiCreateFourthlineProcessErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
    case ApiCreateFourthlineProcessErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_KYC_PROCESS_NOT_RETRYABLE:
      return "UNPROCESSABLE_ENTITY_ERROR_KYC_PROCESS_NOT_RETRYABLE";
    case ApiCreateFourthlineProcessErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_VALIDATION_ERROR:
      return "UNPROCESSABLE_ENTITY_ERROR_VALIDATION_ERROR";
    case ApiCreateFourthlineProcessErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_FAILED_TO_SPLIT_DOCUMENT:
      return "UNPROCESSABLE_ENTITY_ERROR_FAILED_TO_SPLIT_DOCUMENT";
    default:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
  }
}

/** Conflict error codes. */
export const ApiCreateFourthlineProcessErrorsConflictError = {
  /** CONFLICT_ERROR_UNSPECIFIED - Unspecified conflict error. */
  CONFLICT_ERROR_UNSPECIFIED: "CONFLICT_ERROR_UNSPECIFIED",
  /** CONFLICT_ERROR_CONTRACT_DOCUMENT_NOT_READY - The product selection contract is not ready yet. */
  CONFLICT_ERROR_CONTRACT_DOCUMENT_NOT_READY: "CONFLICT_ERROR_CONTRACT_DOCUMENT_NOT_READY",
} as const;

export type ApiCreateFourthlineProcessErrorsConflictError =
  typeof ApiCreateFourthlineProcessErrorsConflictError[keyof typeof ApiCreateFourthlineProcessErrorsConflictError];

export namespace ApiCreateFourthlineProcessErrorsConflictError {
  export type CONFLICT_ERROR_UNSPECIFIED =
    typeof ApiCreateFourthlineProcessErrorsConflictError.CONFLICT_ERROR_UNSPECIFIED;
  export type CONFLICT_ERROR_CONTRACT_DOCUMENT_NOT_READY =
    typeof ApiCreateFourthlineProcessErrorsConflictError.CONFLICT_ERROR_CONTRACT_DOCUMENT_NOT_READY;
}

export function apiCreateFourthlineProcessErrorsConflictErrorFromJSON(
  object: any,
): ApiCreateFourthlineProcessErrorsConflictError {
  switch (object) {
    case 0:
    case "CONFLICT_ERROR_UNSPECIFIED":
      return ApiCreateFourthlineProcessErrorsConflictError.CONFLICT_ERROR_UNSPECIFIED;
    case 1:
    case "CONFLICT_ERROR_CONTRACT_DOCUMENT_NOT_READY":
      return ApiCreateFourthlineProcessErrorsConflictError.CONFLICT_ERROR_CONTRACT_DOCUMENT_NOT_READY;
    default:
      return ApiCreateFourthlineProcessErrorsConflictError.CONFLICT_ERROR_UNSPECIFIED;
  }
}

export function apiCreateFourthlineProcessErrorsConflictErrorToJSON(
  object: ApiCreateFourthlineProcessErrorsConflictError,
): string {
  switch (object) {
    case ApiCreateFourthlineProcessErrorsConflictError.CONFLICT_ERROR_UNSPECIFIED:
      return "CONFLICT_ERROR_UNSPECIFIED";
    case ApiCreateFourthlineProcessErrorsConflictError.CONFLICT_ERROR_CONTRACT_DOCUMENT_NOT_READY:
      return "CONFLICT_ERROR_CONTRACT_DOCUMENT_NOT_READY";
    default:
      return "CONFLICT_ERROR_UNSPECIFIED";
  }
}

export const ApiCreateFourthlineProcessRequest: MessageFns<ApiCreateFourthlineProcessRequest> = {
  fromJSON(object: any): ApiCreateFourthlineProcessRequest {
    return { identityId: isSet(object.identity_id) ? globalThis.String(object.identity_id) : "" };
  },

  toJSON(message: ApiCreateFourthlineProcessRequest): unknown {
    const obj: any = {};
    if (message.identityId !== undefined && message.identityId !== null) {
      obj.identity_id = message.identityId;
    }
    return obj;
  },
};

export const ApiCreateFourthlineProcessResponse: MessageFns<ApiCreateFourthlineProcessResponse> = {
  fromJSON(object: any): ApiCreateFourthlineProcessResponse {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      providerToken: isSet(object.provider_token) ? globalThis.String(object.provider_token) : "",
      redirectUrl: isSet(object.redirect_url) ? globalThis.String(object.redirect_url) : "",
      isQesRequired: isSet(object.is_qes_required) ? globalThis.Boolean(object.is_qes_required) : false,
    };
  },

  toJSON(message: ApiCreateFourthlineProcessResponse): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.providerToken !== undefined && message.providerToken !== null) {
      obj.provider_token = message.providerToken;
    }
    if (message.redirectUrl !== undefined && message.redirectUrl !== null) {
      obj.redirect_url = message.redirectUrl;
    }
    if (message.isQesRequired !== undefined && message.isQesRequired !== null) {
      obj.is_qes_required = message.isQesRequired;
    }
    return obj;
  },
};

export const ApiCreateFourthlineProcessErrors: MessageFns<ApiCreateFourthlineProcessErrors> = {
  fromJSON(_: any): ApiCreateFourthlineProcessErrors {
    return {};
  },

  toJSON(_: ApiCreateFourthlineProcessErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
